// @odeniel -> se esta migrando a bindFactory ...

export default function initChildScopeFactory(data, dictonary, ecFormBuilderController) {
  return function initChildScope(childScope, xPath, isMultiple = false) {
    console.warn('DEPRECATED - si vez este mensaje, por favor avisa a @odeniel', xPath);
    // añade en el scope los datos:
    // initChildScope(scope, 'CAB.LIN')
    // scope.model === scope.LIN === scope.CAB.LIN
    // scope.nameRegister = 'LIN'
    //

    const model = xPath.split('.').slice(-1)[0];
    //
    // copiamos el objeto "CAB" en el scope
    Object.assign(childScope, data);
    // añadimos el nombre del registro ej. "NAD"
    childScope.nameRegister = model;

    if (isMultiple) {
      // si es un array
      const _data = getArray(xPath);
      /* @odeniel 02/07/2019
      quito esto que no es realmente correcto y genera confusión.
      Por ejemplo el grid usa campo "current" y no "model" para el selected...
      childScope.model = childScope.model || _data[0] || null; //default first row selected
      @odeniel 02/07/2019 */
      initDataArray(_data, 'data');
      initDataArray(_data, model);
    } else {
      // si es un objeto
      childScope.data = getObject(xPath);
      childScope[model] = childScope.data;
    }
    childScope.ecFormBuilderController = ecFormBuilderController;

    function initDataArray(data, propertyName) {
      // @odeniel - arr es el array inicial, ojo que queremos modificarlo pero NO reasignarlo
      const empty = arr => arr.splice(0, arr.length);
      const merge = (arr, arrToMerge) => (arr || []).push.apply(arr, arrToMerge);
      //
      Object.defineProperty(childScope, propertyName, {
        get: () => data,
        set: values => {
          if (!Array.isArray(values)) {
            throw new Error(`ecFormBuilder "${xPath}": intentas asignar un "${typeof values}": ${values}, pero no es un "array".`);
          }
          empty(data);
          merge(data, values);
        },
        enumerable: true,
        configurable: true,
      });
    }

    function getArray(path) {
      const model = path.split('.').pop(),
        parentPath = path
          .split('.')
          .slice(0, path.split('.').length - 1)
          .join('.');
      //
      const parent = getObject(parentPath);
      parent[model] = parent[model] || [];
      return parent[model];
    }

    function getObject(path) {
      if (!path) {
        return {};
      }
      const model = path.split('.').pop(),
        parentPath = path
          .split('.')
          .slice(0, path.split('.').length - 1)
          .join('.');
      //
      // buscamos el registro padre en varios niveles de scope.$parent ya que por ejemplo en el grid, cell popup, son 2 scopes antes de encontrar la linea coriente
      let data = childScope[model] || childScope.$parent[model] || childScope.$parent.$parent[model] || childScope.$parent.$parent.$parent[model];
      if (Array.isArray(data)) {
        throw new Error(`ecFormBuilder ${path}: found an 'array' "${model}" when 'object' wanted`);
      }
      if (!data) {
        const parent = getObject(parentPath);
        parent[model] = parent[model] || {};
        data = parent[model];
      }
      return data;
    }
  };
}
